import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import Testimonials from "@/pages/Testimonials";

export const Route = createFileRoute("/testimonials")({
  head: () => pageHead({
    title: 'Customer Testimonials',
    description: 'Read real reviews from Rex & Sons RVs customers — see why families across southeastern North Carolina trust us for RV sales and service.',
    path: '/testimonials',
  }),
  component: Testimonials,
});
